import { ARROW_SIZE, SPACING_FROM_NEAREST_CORNER } from './constants.js';
import { Shadows, getFocusStyles } from '@doordash/design-language';
import styled, { css } from 'styled-components';
import { AnchoredLayerPosition } from '@doordash/component-layer-manager';

var PopoverContainer = styled.div.withConfig({
  displayName: "styles__PopoverContainer",
  componentId: "sc-1bzxqok-0"
})(["background:", ";border-radius:", "px;box-shadow:", ";display:flex;align-items:flex-start;overflow:auto;outline:none;&&:focus{", ";}"], function (props) {
  return props.backgroundColor;
}, function (props) {
  return props.borderRadius;
}, Shadows.Large, function (props) {
  return getFocusStyles({
    theme: props.theme
  });
});
var ArrowStyle = css([""]);

var getStyleForPosition = function getStyleForPosition(_ref) {
  var backgroundColor = _ref.backgroundColor,
      position = _ref.position;

  switch (position) {
    case AnchoredLayerPosition.TopLeft:
    case AnchoredLayerPosition.TopCenter:
    case AnchoredLayerPosition.TopRight:
      {
        var TRIANGLE = css(["", ";border-left:", "px solid transparent;border-right:", "px solid transparent;border-top:", "px solid ", ";bottom:-", "px;"], ArrowStyle, ARROW_SIZE, ARROW_SIZE, ARROW_SIZE, backgroundColor, ARROW_SIZE);

        switch (position) {
          case AnchoredLayerPosition.TopLeft:
          case AnchoredLayerPosition.TopRight:
            return css(["", ";", ":", "px;"], TRIANGLE, position === AnchoredLayerPosition.TopLeft ? 'left' : 'right', SPACING_FROM_NEAREST_CORNER);

          case AnchoredLayerPosition.TopCenter:
          default:
            return css(["", ";left:0px;right:0px;"], TRIANGLE);
        }
      }

    case AnchoredLayerPosition.RightTop:
    case AnchoredLayerPosition.RightCenter:
    case AnchoredLayerPosition.RightBottom:
      {
        var _TRIANGLE = css(["", ";border-top:", "px solid transparent;border-bottom:", "px solid transparent;border-right:", "px solid ", ";left:-", "px;"], ArrowStyle, ARROW_SIZE, ARROW_SIZE, ARROW_SIZE, backgroundColor, ARROW_SIZE);

        switch (position) {
          case AnchoredLayerPosition.RightTop:
          case AnchoredLayerPosition.RightBottom:
            return css(["", ";", ":", "px;"], _TRIANGLE, position === AnchoredLayerPosition.RightTop ? 'top' : 'bottom', SPACING_FROM_NEAREST_CORNER * 1.5);

          case AnchoredLayerPosition.RightCenter:
          default:
            return css(["", ";margin:auto;top:0px;bottom:0px;"], _TRIANGLE);
        }
      }

    case AnchoredLayerPosition.LeftTop:
    case AnchoredLayerPosition.LeftCenter:
    case AnchoredLayerPosition.LeftBottom:
      {
        var _TRIANGLE2 = css(["", ";border-top:", "px solid transparent;border-bottom:", "px solid transparent;border-left:", "px solid ", ";right:-", "px;"], ArrowStyle, ARROW_SIZE, ARROW_SIZE, ARROW_SIZE, backgroundColor, ARROW_SIZE);

        switch (position) {
          case AnchoredLayerPosition.LeftTop:
          case AnchoredLayerPosition.LeftBottom:
            return css(["", ";", ":", "px;"], _TRIANGLE2, position === AnchoredLayerPosition.LeftTop ? 'top' : 'bottom', SPACING_FROM_NEAREST_CORNER);

          case AnchoredLayerPosition.LeftCenter:
          default:
            return css(["", ";margin:auto;top:0px;bottom:0px;"], _TRIANGLE2);
        }
      }

    case AnchoredLayerPosition.BottomLeft:
    case AnchoredLayerPosition.BottomCenter:
    case AnchoredLayerPosition.BottomRight:
      {
        var _TRIANGLE3 = css(["", ";border-left:", "px solid transparent;border-right:", "px solid transparent;border-bottom:", "px solid ", ";top:-", "px;"], ArrowStyle, ARROW_SIZE, ARROW_SIZE, ARROW_SIZE, backgroundColor, ARROW_SIZE);

        switch (position) {
          case AnchoredLayerPosition.BottomLeft:
          case AnchoredLayerPosition.BottomRight:
            return css(["", ";", ":", "px;"], _TRIANGLE3, position === AnchoredLayerPosition.BottomLeft ? 'left' : 'right', SPACING_FROM_NEAREST_CORNER * 1.5);

          case AnchoredLayerPosition.BottomCenter:
          default:
            return css(["", ";left:0px;right:0px;"], _TRIANGLE3);
        }
      }

    default:
      return css([""]);
  }
};

var Arrow = styled.div.withConfig({
  displayName: "styles__Arrow",
  componentId: "sc-1bzxqok-1"
})(["width:0;height:0;position:absolute;", ";"], getStyleForPosition);

export { Arrow, PopoverContainer };
